export default "__VITE_ASSET__DjNs3UlA__"